import EditComponents from '~extension/edit-components';

export default function EditComponentsPage() {
  return <EditComponents />;
}
